import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Footer } from './Footer'
import { Logo } from '../ui/Logo'
import { SkipLinks } from '@/components/accessibility/SkipLinks'

interface PublicLayoutProps {
  children: ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="min-h-screen bg-neutral-50 flex flex-col">
      {/* WCAG 2.1 SC 2.4.1 (Bypass Blocks). Public-facing pages including
          onboarding (which collects bank details) and the legal pages must
          offer a skip-to-content target. */}
      <SkipLinks />

      {/* Public Header */}
      <header className="bg-white border-b-2 border-neutral-300" role="banner">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
          <div className="flex justify-between items-center py-6">
            <Link to="/" className="flex items-center">
              <Logo size="md" showSlogan={true} />
            </Link>
            <nav id="navigation" aria-label="Main" className="flex space-x-8">
              <Link to="/login" className="text-lg text-neutral-600 hover:text-neutral-900 font-medium">
                Login
              </Link>
              <Link to="/onboarding" className="text-lg text-neutral-600 hover:text-neutral-900 font-medium">
                Register
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main id="main-content" className="flex-1" role="main" tabIndex={-1}>
        {children}
      </main>

      {/* Footer */}
      <footer role="contentinfo">
        <Footer />
      </footer>
    </div>
  )
}
